import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { environment } from 'src/environments/environment';
import { computed } from '@angular/core';
import { MarginPipelineRequest } from '../../models/contract-request/margin-pipeline-request.model';
import { ContractRequestsSlice, initialContractRequestsSlice } from './contract-requests.slice';

export const ContractRequestsStore = signalStore(
    { providedIn: 'root' },
    withState(initialContractRequestsSlice),
    withComputed((store) => ({
        snapshot: computed<ContractRequestsSlice>(() => ({
            marginPipelineRequests: store.marginPipelineRequests()
        }))
    })),
    withMethods((store) => ({
        updateMarginPipelineRequestsFromData: (data: MarginPipelineRequest[]) => {
            patchState(store, { marginPipelineRequests: data });
        },
        getState: () => store,
        getSnapshot: () => store.snapshot()
    })),
    environment.storeWithDevTools('locums-margin-calculator-contract-requests-store')
);
